import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class QuotaAggregateService extends ApiService {
  constructor(private http: Http) {
    super('api/quotas-stocks/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/quota-aggregate.service.ts